export const GA_EVENT_TYPE = {
    /** 瀏覽桌布頁面 */
    VIEW_WALLPAPEPR_PAGE: 'VIEW_WALLPAPEPR_PAGE',
    /** 瀏覽下載頁面 */
    VIEW_DOWNLOAD_PAGE: 'VIEW_DOWNLOAD_PAGE',
    /** 我的桌布 */
    MY_WALLPAPER: 'MY_WALLPAPER',
    /** 預約鑑賞 */
    BOOKING: 'BOOKING',
    /** 探索作品 */
    EXPLORE_COLLECTIONS: 'EXPLORE_COLLECTIONS',
    /** 前往下載頁面 */
    GO_DOWNLOAD_PAGE: 'GO_DOWNLOAD_PAGE',
    /** 前往分享頁面 */
    GO_SAHRE_PAGE: 'GO_SAHRE_PAGE',
    /** 點擊分享好友按鈕 */
    CLICK_SHARE_BTN: 'CLICK_SHARE_BTN',
    /** 分享成功 */
    SHARE_SUCCESS: 'SHARE_SUCCESS',
    /** 分享成功的桌布 Id */
    SHARE_PAPER_ID: 'SHARE_PAPER_ID',
    /** 瀏覽桌布綁定系列頁面 */
    VIEW_WALLPAPEPR_SERIES_PAGE: 'VIEW_WALLPAPEPR_SERIES_PAGE',
    /** 點擊側欄 */
    CLICK_SIDEMENU: 'CLICK_SIDEMENU'
};

export const GA_PAGE_VIEW_TYPE = {
    /** 進入專屬桌布集錦頁面 */
    view_wallpaper_page: 'view_wallpaper_page',
    /** 進入下載桌布頁面 */
    download_wallpaper: 'download_wallpaper',
    /** 進入分享桌布頁面 */
    share_wallpaper: 'share_wallpaper',
    /** 進入收藏系列頁 */
    view_wallpaper_series_page: 'view_wallpaper_series_page'
};

export const EXTERNAL_URL = {
    MY_WALLPAPER: '/',
    BOOKING: 'https://maac.io/4cVbx',
    EXPLORE_COLLECTIONS: 'https://maac.io/4Jdon'
};

export const GATYPE = 'hw';

export const REDIRECT_ROUTE = 'wallpaper';
